<template>
  <div class="carousel">
    <BaseSwiper
      :options="{ spaceBetween: 100 }"
      :tap-to-continue="true">
      <template #header>
        <div class="header">
          <img class="flag" :src="opponent.flagImage">
          <BaseText3 class="name" :text="opponent.name"/>
        </div>
      </template>
      <SwiperSlide>
        <BaseRadarChart :data="radarChartData"/>
      </SwiperSlide>
      <SwiperSlide>
        <BaseBarChart :data="barChartData"/>
      </SwiperSlide>
      <template #footer>
        <BaseText2 class="instruction" text="Swipe for more"/>
      </template>
    </BaseSwiper>
    <BaseButtonExpand class="button" state="close" @click.native="$emit('close')"/>
  </div>
</template>

<script>
import BaseText2 from '@/components/BaseText2/BaseText2'
import BaseText3 from '@/components/BaseText3/BaseText3'
import BaseSwiper from '@/components/BaseSwiper/BaseSwiper'
import BaseRadarChart from '@/components/BaseRadarChart/BaseRadarChart'
import BaseBarChart from '@/components/BaseBarChart/BaseBarChart'
import SwiperSlide from '@/components/BaseSwiper/components/SwiperSlide/SwiperSlide'
import BaseButtonExpand from '@/components/BaseButtonExpand/BaseButtonExpand'
import { calcFilteredAverages } from '@/utils/emotionSeriesUtils'
import { mapGetters } from 'vuex'
export default {
  components: {
    BaseSwiper,
    BaseRadarChart,
    BaseBarChart,
    BaseButtonExpand,
    SwiperSlide,
    BaseText2,
    BaseText3
  },
  props: {
    opponent: {
      type: Object,
      required: true
    },
    round: {
      validator: prop => typeof prop === 'object' || prop === null,
      required: true
    }
  },
  computed: {
    ...mapGetters('gameplay', [
      'emotionsFiltered'
    ]),
    radarChartData () {
      return {
        labels: this.emotionsFiltered.map(emotion => emotion.alias.toUpperCase()),
        datasets: [
          calcFilteredAverages(this.round.emotionSeries),
          calcFilteredAverages(this.opponent.emotionSeries)
        ]
      }
    },
    barChartData () {
      return this.emotionsFiltered.map((emotion, i) => ({
        label: emotion.alias,
        val1: (calcFilteredAverages(this.opponent.emotionSeries)[i] * 100).toFixed(),
        val2: (calcFilteredAverages(this.round.emotionSeries)[i] * 100).toFixed()
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.75;
    background-color: var(--color-black-2);
    background-position: center center;
    background-size: cover;
    z-index: 0;
  }
}
.base-swiper {
  padding: var(--spacing-1) var(--spacing-2);
}
.header {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
}
.flag {
  height: 1rem;
  margin-bottom: 0.75rem;
}
.name {
  text-align: left;
  font-size: 1.8rem;
}
.base-radar-chart {
  width: 70%;
  margin: auto;
}
.instruction {
  margin-bottom: var(--spacing-2);
}
.button {
  position: absolute;
  top: 0;
  right: 0;
  margin: var(--spacing-2);
}
</style>
